import { useEffect, useRef, useState } from 'react'

export const useShowDropdown = () => {
  const [showDropdown, setShowDropdown] = useState(false)
  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const onClick = (e: any) => {
      if (ref.current && ref.current.contains(e.target)) {
        setShowDropdown((prev) => !prev)
      } else {
        setShowDropdown(false)
      }
    }
    document.addEventListener('click', onClick, true)
    return () => document.removeEventListener('click', onClick, true)
  }, [])

  return { ref, showDropdown, setShowDropdown}
}
